import axios from 'axios';
import { BASE_API_URL } from '../constants/apiUrls';

const API_URL = `${BASE_API_URL}/enterprise-dynamic-video-automation`;

export const generateScenesRequest = async (data: any) => {

    const requestData = {
        mode: "content-extraction",
        video_creation_mode: "create_edit",
        input_url: data.inputUrl,
        video_title: data.videoName,
        background_video: {
            "url": localStorage.getItem('selectedBackgroundVideo')
        },
        voice: {
            "voiceName": data.selectedVoice.voiceName,
            "voiceLanguageCode": data.selectedVoice.voiceLanguageCode,
            "speed": 1,
            "style":"NewsCast",
            "pitch": 0,
            "default_tone": ["NewsCast"],
            "source": data.selectedVoice.source
        },
        music: {
            "asset_url": data.selectedMusic
        },
        is_music_selected: data.selectedMusic !== "" ? true : false,
        language: "English",
        aspect_ratio: "landscape",
        source_platform: "add_ins",
        category_mode:"",
        paid_flow: false,
        input_type: "document",
        video_duration: {
            "durationMin": data.duration[0],
            "durationMax": data.duration[1]
        },
        video_caption: data.videoCaption
    }

    try {
        const response = await axios.post(API_URL, requestData, {
            headers: {
                'accept': 'application/json, text/plain, */*',
                'accept-language': 'en-US,en-GB;q=0.9,en;q=0.8,tr-TR;q=0.7,tr;q=0.6',
                'authorization': `Bearer ${localStorage.getItem('vmPluginAccessToken')}`,
                'content-type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching scenes:', error);
        throw error;
    }
};

export const generateMultiScriptRequest = async (selected_data : any) => {

    const requestData = {
        id: selected_data.data.id,
        job_id : selected_data.data.id,
        scene_tone: "professional",
        data: {
            category_mode: selected_data.data.category_mode,
            input_type : selected_data.data.input_type,
            input_url: selected_data.data.input_url,
            is_user_draft: selected_data.data.is_user_draft,
            is_music_selected: selected_data.data.music.asset_url !== "" ? true : false,
            language: "English",
            voice: selected_data.data.voice,
            music: selected_data.data.music,
            video_title: selected_data.data.video_title,
            scenes: selected_data.data.scenes.professional
        }
    }

    try {
        const response = await axios.post(`${BASE_API_URL}/enterprise-multi-scripts`, requestData, {
            headers: {
                'accept': 'application/json, text/plain, */*',
                'accept-language': 'en-US,en-GB;q=0.9,en;q=0.8,tr-TR;q=0.7,tr;q=0.6',
                'authorization': `Bearer ${localStorage.getItem('vmPluginAccessToken')}`,
                'content-type': 'application/json'
            }
        });
        console.log("Here is the multi script response", response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching scenes:', error);
        throw error;
    }
}

